<!-- Header section -->
<login-header id="ourStory"></login-header>

<!-- Hero section -->
<div class="lp_hero gradient_bg" style="background-image: url('/assets/images/ourteam-bg.webp');">
    <div class="lp_hero_content d-md-grid align-items-center">
        <div class="lp_hero_image">
            <img class="w-100" src="/assets/images/about-hero-image.webp" alt="">
        </div>
        <div class="lp_hero_text">
            <p class="our_story_txt mb-4">Our Story</p>
            <h1 class="lp_h1 mb-4">A helping hand for you and the ones that matter most — your family.</h1>
            <p class="mb-0 lp_p">We created Family Central because we all have found ourselves wishing we and our families had the right tools to help us through life’s inevitable emergencies and times of grief.</p>
        </div>
    </div>
</div>

<!-- Founder Details -->
<div class="founder_section">
    <div class="px-90 m-auto">
        <div class="founder_content">
            <div class="founder_photo">
                <img class="w-100" src="/assets/images/jason-brown-photo.webp" alt="" loading="lazy">
            </div>
            <div class="founder_details">
                <h2 class="lp_h2">“ I want to save families the heartache I endured.”</h2>
                <h3 class="lp_h3 text-end mb-5">Jason Brown, founder and CEO</h3>

                <p class="lp_p">Jason Brown created Family Central to protect families from the additional heartache that comes with not being prepared for the death of a loved one. He knows that heartache all too well.</p>
                <p class="lp_p">When Jason was 20 years old, he, his girlfriend, and her two sons were in a car crash. His girlfriend, Kathryn, died immediately. Sitting on the road, holding two crying children, Jason was devastated and lost. He and Kathryn had never planned for such an unthinkable tragedy.</p>

                <div id="readMore" class="collapse">
                    <div class="founder_expand lp_p">
                        <p>Now, facing it without her, Jason had to piece not only his life but the lives of Kathryn's two sons back together. Looking at the two boys, 6 and 7 at the time, he knew instantly he wanted to take care of them in Kathryn's absence, and in her honor. "I'm sitting in a hotel that night with crying children, my girlfriend gone," Jason said. "I knew I had to adopt them."</p>
        
                        <p>Adopting the kids wouldn't be easy. Jason had no legal connection to the children. He and Kathryn had also never spoken about their wishes should one of them die, and she didn't have a will.</p>
        
                        <p>"What ensued was a massive mess. It was the worst time of my life," Jason said.</p>
        
                        <p>Jason spent half a year fighting to adopt the boys. He needed to establish he was mentally fit to take care of the children, endure legal battles with their biological father and the state, and even handle an FBI warrant for his arrest, accused of kidnapping only days after Kathryn's death.</p>
        
                        <p>"I spent months fighting for the kids, all because there was no plan," Jason said.</p>
        
                        <p>The trauma, which did eventually result in Jason being able to adopt the kids, is what inspired him to create Family Central.</p>
        
                        <p>"We can help millions of people around the globe to sort out their family's affairs without the chaos and nastiness that I had to go through," Jason said. "We give families a safe haven to securely store their most valuable information. By making it easier to stay organized, we also make it possible to focus on bigger-picture planning and creating family legacies to preserve for generations to come."</p>
        
                        <p>Now, with Family Central, Jason is able to plan ahead to protect his family both today and for a future without him. He's recording videos for his loved ones so they have memories and wisdom they can treasure for years to come, like giving lessons to his young daughter and telling his wife how much he loves her</p>
        
                        <p><strong>"My responsibility in life doesn't end when my life ends," Jason said. "I care about people when I'm alive. Why wouldn't I care about them when I go?"</strong></p>
                    </div>
                </div>

                <button id="ourTeam" type="button" class="read_more_btn fw-700 text-decoration-underline" data-bs-toggle="collapse" data-bs-target="#readMore" aria-expanded="false">
                    <span class="read_more_txt">Read more</span>
                    <span class="read_less_txt">Read less</span>
                </button>
            </div>
        </div>

    </div>
</div>

<!-- Our team -->
<div class="our_team gradient_bg" style="background-image: url('/assets/images/ourteam-bg.webp');">
    <div class="px-90 m-auto">
        <div class="our_team_top text-center">
            <h2 class="lp_h2">Our Team</h2>
            <p class="lp_p">The Family Central founding team includes a dedicated technology team that has worked with our co-founders for over two decades, as well as an integrated group that runs all the facets of UX/UI design, customer care/retention, marketing and social media.</p>
        </div>

        <div class="founders_list d-flex flex-wrap justify-content-center text-center">
            <div class="single_member">
                <div class="member_photo">
                    <img src="/assets/images/jason-circle-image.webp" width="123" height="123" alt="" loading="lazy">
                </div>
                <div class="member_details">
                    <h3 class="lp_h3">Jason Brown</h3>
                    <p>CEO & Co-founder</p>
                </div>
            </div>
            <div class="single_member">
                <div class="member_photo">
                    <img src="/assets/images/bob-circle-image.webp" width="123" height="123" alt="" loading="lazy">
                </div>
                <div class="member_details">
                    <h3 class="lp_h3">Bob Barton</h3>
                    <p>CFO & Co-founder</p>
                </div>
            </div>
            <div class="single_member">
                <div class="member_photo">
                    <img src="/assets/images/prem-circle-image.webp" width="123" height="123" alt="" loading="lazy">
                </div>
                <div class="member_details">
                    <h3 class="lp_h3">Prem Thudia</h3>
                    <p>CTO & Co-founder</p>
                </div>
            </div>
        </div>

        <div class="founders_list board_members d-flex flex-wrap justify-content-center text-center">
            <div class="single_member">
                <div class="member_photo">
                    <img src="/assets/images/scott-circle-image.webp" width="123" height="123" alt="" loading="lazy">
                </div>
                <div class="member_details">
                    <h3 class="lp_h3">Scott Slatin</h3>
                    <p>Dedicated DTC Marketing Expertise</p>
                </div>
            </div>
            <div class="single_member">
                <div class="member_photo">
                    <img src="/assets/images/cavan-circle-image.webp" width="123" height="123" alt="" loading="lazy">
                </div>
                <div class="member_details">
                    <h3 class="lp_h3">Cavan Reagan Reichmann</h3>
                    <p>CMO</p>
                </div>
            </div>
            <div class="single_member">
                <div class="member_photo">
                    <img src="/assets/images/abby-circle-image.webp" width="123" height="123" alt="" loading="lazy">
                </div>
                <div class="member_details">
                    <h3 class="lp_h3">Abby Salazar</h3>
                    <p>UX/UI Design</p>
                </div>
            </div>
            <div class="single_member">
                <div class="member_photo">
                    <img src="/assets/images/mark-circle-image.webp" width="123" height="123" alt="" loading="lazy">
                </div>
                <div class="member_details">
                    <h3 class="lp_h3">Dr. Mark Freeman</h3>
                    <p>Research & Development</p>
                </div>
            </div>
            <div class="single_member">
                <div class="member_photo">
                    <img src="/assets/images/ali-circle-image.webp" width="123" height="123" alt="" loading="lazy">
                </div>
                <div class="member_details">
                    <h3 class="lp_h3">Alison Briggs</h3>
                    <p>Project Management</p>
                </div>
            </div>
        </div>

    </div>
</div>


<div class="about_carousel">
    <div class="px-90 m-auto">
        <div class="carousel_content d-xl-grid gap-5 gap-xxl-0 align-items-center">
            <app-circular-carousel></app-circular-carousel>
            <app-get-started-box></app-get-started-box>
        </div>
    </div>
</div>


<!-- Footer section -->
<app-footer></app-footer>